
import React from 'react';
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle, CardFooter } from "@/components/ui/card";
import { DocumentIcon, ViewIcon } from '../../BorrowingsIcons';
import { formatDate } from '../utils';

interface DocumentsTabProps {
  documents: any[];
}

export const DocumentsTab: React.FC<DocumentsTabProps> = ({ documents }) => {
  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-lg">Loan Documents</CardTitle>
        <CardDescription>
          Agreements and supporting documentation
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {documents.map((doc: any, idx: number) => (
            <div key={idx} className="flex items-center p-3 border rounded-md">
              <div className="flex-1">
                <div className="font-medium flex items-center gap-2">
                  <DocumentIcon className="h-4 w-4" />
                  {doc.name}
                </div>
                <div className="text-xs text-muted-foreground mt-1">
                  Added: {formatDate(doc.date)}
                </div>
              </div>
              <Button variant="ghost" size="sm">
                <ViewIcon className="h-4 w-4 mr-1" />
                View
              </Button>
            </div>
          ))}
        </div>
      </CardContent>
      <CardFooter className="bg-muted/50 py-3">
        <Button className="ml-auto" size="sm">Upload Document</Button>
      </CardFooter>
    </Card>
  );
};
